<template>
    <div :class="[$options.name, 'white']">
        <div class="container">
            <ul class="menu -ul">
                <li 
                    class="menu -li" 
                    v-for="(route, index) in routes" 
                    :key="`route-${index}`"
                >
                    <button 
                        @click="goToSection(route)"
                        :class="[
                            'url', 
                            { 
                                '-active': $route.name === 'home' && route === getActiveRoute() 
                            }
                        ]"
                    >
                        {{ route }}
                    </button>
                </li>
            </ul>
            <mentions />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Mentions from '@/components/Mentions'

export default {
    name: 'menu-overlay',
    data() {
        return {
            routes: ['about', 'work', 'contact']
        }
    },
    computed: {
        ...mapGetters({
            isMenuOpen: 'isMenuOpen',
            fullPageApi: 'getFullPageApi',
            homePageSections: 'getHomePageSections'
        })
    },
    components: {
        'mentions': Mentions
    },
    methods: {
        goToSection(route) {
            let redirect = route === 'work' ? this.projectsList[0].slug : route
            if (this.$route.name === 'home') {
                fullpage_api.moveTo(redirect)
            } else {
                this.$router.push({ name: 'home' })
                this.$store.dispatch('updateSectionClicked', redirect)
            }
            this.$store.dispatch('toggleMenuOverlay', false)
        },
        getActiveRoute() {
            let currentSection 
            if (this.fullPageApi) {
                currentSection = fullpage_api.getActiveSection().index
            } else {
                currentSection = this.$route.name === 'home' ? 0 : 1
            }
            if (currentSection === this.homePageSections.indexOf('about')) {
                return 'about'
            } else if (
                currentSection >= this.homePageSections.indexOf(this.projectsList[0].slug) && 
                currentSection <= this.homePageSections.indexOf(this.projectsList[this.projectsList.length - 1].slug)
            ) {
                return 'work'
            } else if (currentSection === this.homePageSections.indexOf('contact')) {
                return 'contact'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.menu-overlay {
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 100vh;
    position: fixed;
    background-color: $white;
    height: calc(var(--vh, 1vh) * 100);
    animation: openMenu 0.5s cubic-bezier(0.64, 0.57, 0.67, 1.53);
    &::before,
    &::after {
        content: '';
        width: 50%;
        height: 100%;
        position: absolute;
        background-color: $white;
    }
    &::before {
        left: -25%;
        border-radius: 50%;
    }
    &::after {
        left: 75%;
    }
    .container {
        width: 80%;
        height: 100%;
        margin: 0 auto;
        position: relative;
    }
    .-ul {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        position: absolute;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        .-li {
            width: 100%;
            text-align: center;
            margin: 0.2rem auto;
            color: var(--bg-color);
            text-decoration: none;
            .url {
                text-transform: capitalize;
                @include g-state(tablet) {
                    font-size : 1.8rem;
                }
                &.-active {
                    pointer-events: none;
                    text-decoration: line-through;
                }
            }
        }
    }
}
@keyframes openMenu {
    0% {
        left: 50%;
        opacity: 0;
        transform: translateX(50%);
    }
    100% {
        opacity: 1;
        transform: none;
    }
}
</style>

